import { useQuery } from '@tanstack/react-query'

import { fetchClubsSearch, type ParticipantFilter } from '../lib/clubsListApi'
import { ClubsQueryKeys } from './index'

export function useClubsSearch(
  search: string,
  sportTypeId?: string,
  enabled = true,
  participantType?: ParticipantFilter
) {
  const trimmed = search.trim()
  const isSearchReady = trimmed.length > 0

  const result = useQuery({
    queryKey: [
      ClubsQueryKeys.CLUBS_LIST,
      'search',
      sportTypeId,
      trimmed,
      participantType
    ],
    queryFn: () =>
      fetchClubsSearch({ sportTypeId, search: trimmed, participantType }),
    enabled: enabled && isSearchReady,
    staleTime: 60 * 1000
  })

  return {
    // eslint-disable-next-line @tanstack/query/no-rest-destructuring -- convenience API mirrors useLocationsSearch
    ...result,
    clubs: result.data ?? [],
    isSearchReady
  }
}
